import { render } from "./BuildingFundFulfilment.vue?vue&type=template&id=bfa6573c"
import script from "./BuildingFundFulfilment.vue?vue&type=script&lang=js"
export * from "./BuildingFundFulfilment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__